(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    

class CustomSlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.slides        = [];
    this.current       = 0;
    this.total         = 0;
    this.transition    = 'fade';
    this.autoplay      = false;
    this.speed         = 5000;
    this.timer         = null;
    this.userPaused    = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  connectedCallback() {
    this.slides     = Array.from(this.querySelectorAll('.cs-slide'));
    this.total      = this.slides.length;
    this.transition = this.dataset.transition || 'fade';
    this.autoplay   = this.dataset.autoplay === 'true';
    this.speed      = (parseInt(this.dataset.speed, 10) || 5) * 1000;

    if (this.total <= 1) return;

    this.initArrows();
    this.initPagination();
    this.initPauseBtn();
    this.initKeyboard();
    this.initTouch();
    this.initFocusPause();

    if (this.autoplay && !this.reducedMotion) {
      this.startAutoplay();
    }
  }

  /* ── Navigation ───────────────────────────────────────────── */

  goTo(index) {
    if (index < 0)           index = this.total - 1;
    if (index >= this.total) index = 0;

    this.current = index;

    /* Always update active class and tabindex — both fade and slide modes */
    this.slides.forEach((slide, i) => {
      const active = i === this.current;
      slide.classList.toggle('cs-slide--active', active);
      slide.setAttribute('tabindex', active ? '0' : '-1');
    });

    /* Slide transition: move the track */
    if (this.transition === 'slide') {
      const track = this.querySelector('.cs-slides-track');
      if (track) track.style.transform = `translateX(${-this.current * 100}%)`;
    }

    this.updatePagination();
    this.updateCounter();
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  /* ── Controls ─────────────────────────────────────────────── */

  initArrows() {
    const prev = this.querySelector('.cs-arrow--prev');
    const next = this.querySelector('.cs-arrow--next');
    if (prev) prev.addEventListener('click', () => { this.prev(); this.pauseAutoplay(); });
    if (next) next.addEventListener('click', () => { this.next(); this.pauseAutoplay(); });
  }

  initPagination() {
    this.querySelectorAll('[data-index]').forEach(btn => {
      btn.addEventListener('click', () => {
        this.goTo(parseInt(btn.dataset.index, 10));
        this.pauseAutoplay();
      });
    });
  }

  updatePagination() {
    this.querySelectorAll('[data-index]').forEach((btn, i) => {
      const active = i === this.current;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  updateCounter() {
    const cur = this.querySelector('.cs-pagination__current');
    if (cur) cur.textContent = this.current + 1;
  }

  initPauseBtn() {
    const btn = this.querySelector('.cs-pause-btn');
    if (!btn) return;
    btn.addEventListener('click', () => {
      this.userPaused = !this.userPaused;
      btn.dataset.paused = this.userPaused;
      btn.setAttribute('aria-label',
        this.userPaused ? btn.dataset.labelPlay : btn.dataset.labelPause
      );
      const pauseIcon = btn.querySelector('.cs-pause-btn__pause');
      const playIcon  = btn.querySelector('.cs-pause-btn__play');
      if (pauseIcon) pauseIcon.style.display = this.userPaused ? 'none' : '';
      if (playIcon)  playIcon.style.display  = this.userPaused ? '' : 'none';
      this.userPaused ? this.pauseAutoplay() : this.startAutoplay();
    });
  }

  initKeyboard() {
    this.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); this.prev(); this.pauseAutoplay(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); this.pauseAutoplay(); }
    });
  }

  initTouch() {
    let startX = 0;
    this.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    this.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? this.next() : this.prev();
        this.pauseAutoplay();
      }
    }, { passive: true });
  }

  initFocusPause() {
    this.addEventListener('focusin',  () => { if (!this.userPaused) this.pauseAutoplay(); });
    this.addEventListener('focusout', () => { if (!this.userPaused) this.startAutoplay(); });
  }

  /* ── Autoplay ─────────────────────────────────────────────── */

  startAutoplay() {
    if (this.reducedMotion || this.userPaused) return;
    this.pauseAutoplay();
    this.timer = setInterval(() => this.next(), this.speed);
  }

  pauseAutoplay() {
    clearInterval(this.timer);
    this.timer = null;
  }
}

customElements.define('custom-slideshow-component', CustomSlideshowComponent);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
